/* eslint-disable max-len */
import { C_ACCOUNT } from '_acaSrc/utility/constants';

export const FORM_SELECTORS = {
    USERNAME: '#mergeUsernameInput',
    PASSWORD: '#mergePasswordInput'
};

export const MERGE_STATUSES = {
    SUCCESS: 'SUCCESS',
    CONSOLIDATE_MERGE_ERROR: C_ACCOUNT.FORM_MESSAGING.MERGE_FAILURE_TYPE.CONSOLIDATE_MERGE_ERROR,
    UNMATCHING_LAST_NAMES: C_ACCOUNT.FORM_MESSAGING.MERGE_FAILURE_TYPE.UNMATCHING_LAST_NAMES,
    CONSOLIDATE_SAME_USER: C_ACCOUNT.FORM_MESSAGING.MERGE_FAILURE_TYPE.CONSOLIDATE_SAME_USER,
    MERGE_RULE_SAME_USER: C_ACCOUNT.FORM_MESSAGING.MERGE_FAILURE_TYPE.MERGE_RULE_SAME_USER
};


export const ERROR_TITLE_MAPPINGS = {
    [C_ACCOUNT.FORM_MESSAGING.MERGE_FAILURE_TYPE.MERGE_RULE_VIOLATION]: C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_TITLE,
    [C_ACCOUNT.FORM_MESSAGING.MERGE_FAILURE_TYPE.CONSOLIDATE_FAILURE]: C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_TITLE,
    [C_ACCOUNT.FORM_MESSAGING.GUID_MERGE_ERROR]: C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_TITLE,
    [C_ACCOUNT.FORM_MESSAGING.WAYF_GENERIC_ERROR_ID]: C_ACCOUNT.FORM_MESSAGING.INCORRECT_USERNAME_PASSWORD,
    [C_ACCOUNT.FORM_MESSAGING.MAXIMUM_ATTEMPTS]: C_ACCOUNT.FORM_MESSAGING.MAX_ATTEMPTS_TITLE,
    [C_ACCOUNT.FORM_MESSAGING.CONSOLIDATE_INCORRECT_SIGN_IN]: C_ACCOUNT.FORM_MESSAGING.ERROR_TITLE,
    [C_ACCOUNT.FORM_MESSAGING.CONSOLIDATE_USER_NOT_FOUND]: C_ACCOUNT.FORM_MESSAGING.ERROR_TITLE
};
